// getters
const cafeteriaRequestsExt = state => state.cafeteriaRequestsExt

export default {
  cafeteriaRequestsExt
}



// WEBPACK FOOTER //
// ./src/store/modules/external/getters.js